// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1863":"a7fcf6e4","2363":"05baacf8","3457":"05baacf8","8875":"05baacf8","8898":"05baacf8","8976":"05baacf8","9933":"05baacf8"}[chunkId] + ".chunk.css";
};